import { combineReducers } from 'redux';
import welcomeCenterDoc from './welcomeCenterDoc';
import techDocReducer from './techDocReducer';
import arrayModel from './arrayModel';

import toggleSideMenu from './toggleSideMenu';

export default combineReducers({
  welcomeCenterDoc,
  techDocReducer,
  // checklistReducer,
  arrayModel,
  toggleSideMenu,
});
